import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var investmentItemMentionListItemApiCalls = {
  fetchInvestmentItemMentionListItemsByInvestmentItemIdInAndAuthUserId: status({
    mapActionToKey: function mapActionToKey(action) {
      return [action.investmentItemIds.join(","), action.authUserId].join("-");
    },
    types: [ActionTypes.GET_INVESTMENTITEMMENTIONLISTITEMSBYINVESTMENTITEMIDINANDAUTHUSERID_REQUEST, ActionTypes.GET_INVESTMENTITEMMENTIONLISTITEMSBYINVESTMENTITEMIDINANDAUTHUSERID_SUCCESS, ActionTypes.GET_INVESTMENTITEMMENTIONLISTITEMSBYINVESTMENTITEMIDINANDAUTHUSERID_FAILURE, ActionTypes.RESET_GET_INVESTMENTITEMMENTIONLISTITEMSBYINVESTMENTITEMIDINANDAUTHUSERID]
  })
};
export default investmentItemMentionListItemApiCalls;